/* eslint-disable */
// @ts-nocheck

import {
  SideNav,
  SideNavItems,
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem,
} from "@carbon/react";
import ESLogo from "../../logo/esLogo";
import React from "react";
import {
  ChildMenuItem,
  ParentMenuItem,
} from "../../../models/navigation/navigationModel";
import { NavLink } from "react-router-dom";
import { MENU_TEXT_GENERAL_TRANSLATIONS } from "../../../translations/util";
import CopyRightFooter from "../../footer/CopyRightFooter";
import { APP_NAME } from "../../../constants";

export const menu: NavigationMenu = {
  items: [
    {
      id: "1",
      menuText: MENU_TEXT_GENERAL_TRANSLATIONS.OverviewMenuItems.parentItem,
      menuRoute: "/overview",
      children: [],
    },
    {
      id: "2",
      menuText:
        MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
          .parentItem,
      children: [
        {
          id: "2-1",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.Organisations,
          menuRoute: "/configurationManagement/organizations",
        },
        {
          id: "2-2",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.OrgTranslations,
          menuRoute: "/configurationManagement/organizationTranslation",
        },
        {
          id: "2-3",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.OrgMappings,
          menuRoute: "/configurationManagement/organizationMapping",
        },
        {
          id: "2-4",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.Locations,
          menuRoute: "/configurationManagement/locations",
        },
        {
          id: "2-5",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.XSSIConnections,
          menuRoute: "/configurationManagement/xssiConnections",
        },
        {
          id: "2-6",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.OTARConnections,
          menuRoute: "/configurationManagement/otarConnections",
        },
        {
          id: "2-7",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.CannedMsgs,
          menuRoute: "/configurationManagement/cannedMessages",
        },
        {
          id: "2-8",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.LMRUsers,
          menuRoute: "/configurationManagement/lmrUsers",
        },
        {
          id: "2-9",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.LMRGroups,
          menuRoute: "/configurationManagement/lmrGroups",
        },
        {
          id: "2-10",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.MCUsers,
          menuRoute: "/configurationManagement/mcpttUsers",
        },
        {
          id: "2-11",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.MCGroups,
          menuRoute: "/configurationManagement/mcpttGroups",
        },
        {
          id: "2-12",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.DFSIConnections,
          menuRoute: "/configurationManagement/dfsiConnections",
        },
        {
          id: "2-13",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.DFSIChannels,
          menuRoute: "/configurationManagement/dfsiChannels",
        },
        {
          id: "2-14",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.DFSIGroups,
          menuRoute: "/configurationManagement/dfsiGroups",
        },
        {
          id: "2-15",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.ConfigurationManagementMenuItems
              .childrenItems.IKIConnections,
          menuRoute: "/configurationManagement/ikiConnections",
        },
      ],
    },
    {
      id: "3",
      menuText:
        MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems.parentItem,
      children: [
        {
          id: "3-1",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems
              .childrenItems.ActiveAlarms,
          menuRoute: "/faultManagement/activeAlarms",
        },
        {
          id: "3-2",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems
              .childrenItems.Faults,
          menuRoute: "/faultManagement/faults",
        },
        {
          id: "3-3",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems
              .childrenItems.Inventory,
          menuRoute: "/faultManagement/inventory",
        },
        {
          id: "3-4",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems
              .childrenItems.Instances,
          menuRoute: "/faultManagement/instances",
        },
        {
          id: "3-5",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.FaultManagementMenuItems
              .childrenItems.HistoricalAlarms,
          menuRoute: "/faultManagement/historicalAlarms",
        },
      ],
    },
    {
      id: "4",
      menuText:
        MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems.parentItem,
      children: [
        {
          id: "4-1",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems
              .childrenItems.PublishInfo,
          menuRoute: "/realtime/publishinfo",
        },
        {
          id: "4-2",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems
              .childrenItems.P25Unit,
          menuRoute: "/realtime/p25unit",
        },
        {
          id: "4-3",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems
              .childrenItems.P25Group,
          menuRoute: "/realtime/p25Group",
        },
        {
          id: "4-4",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems
              .childrenItems.FixedNetwork,
          menuRoute: "/realtime/fixednetworkelement",
        },
        {
          id: "4-5",
          menuText:
            MENU_TEXT_GENERAL_TRANSLATIONS.RealTimeManagementMenuItems
              .childrenItems.Affiliation,
          menuRoute: "/realtime/p25affiliations",
        },
      ],
    },
  ],
};

export default function ESLeftSidebar() {
  const Fade16 = () => (
    <svg
      width="16"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      aria-hidden="true"
    >
      <path d="M8.24 25.14L7 26.67a14 14 0 0 0 4.18 2.44l.68-1.88a12 12 0 0 1-3.62-2.09zm-4.05-7.07l-2 .35A13.89 13.89 0 0 0 3.86 23l1.73-1a11.9 11.9 0 0 1-1.4-3.93zm7.63-13.31l-.68-1.88A14 14 0 0 0 7 5.33l1.24 1.53a12 12 0 0 1 3.58-2.1zM5.59 10L3.86 9a13.89 13.89 0 0 0-1.64 4.54l2 .35A11.9 11.9 0 0 1 5.59 10zM16 2v2a12 12 0 0 1 0 24v2a14 14 0 0 0 0-28z" />
    </svg>
  );

  return (
    <div className="fixed flex flex-col top-0 left-0 h-full text-white transition-all duration-300 border-none z-10 sidebar">
      <div className="overflow-y-auto overflow-x-hidden flex flex-col justify-between flex-grow sidebar-container">
        <ESLogo />

        <SideNav
          isFixedNav
          expanded={true}
          isChildOfHeader={false}
          aria-label="Side navigation"
        >
          <SideNavItems>
            {menu.items.map((item: ParentMenuItem, idx: number) => {
              return (
                <NavLink key={item?.menuRoute} to={item?.menuRoute}>
                  <SideNavMenu
                    key={item.id}
                    renderIcon={Fade16}
                    title={item.menuText}
                    defaultExpanded={window.location.pathname
                      .toLowerCase()
                      .includes(
                        item.menuText.split(" ").join("").toLowerCase()
                      )}
                    isActive={window.location.pathname
                      .toLowerCase()
                      .includes(
                        item.menuText.split(" ").join("").toLowerCase()
                      )}
                  >
                    {item?.children.map((subItem: ChildMenuItem) => {
                      return (
                        <NavLink
                          key={subItem.menuRoute}
                          to={subItem.menuRoute}
                          data-cy={`${subItem.menuText
                            .split(" ")
                            .join("")
                            .toLowerCase()}-menuItem`}
                        >
                          <SideNavMenuItem
                            isActive={window.location.pathname
                              .toLowerCase()
                              .includes(subItem.menuRoute.toLowerCase())}
                          >
                            {subItem.menuText}
                          </SideNavMenuItem>
                        </NavLink>
                      );
                    })}
                  </SideNavMenu>
                </NavLink>
              );
            })}
          </SideNavItems>
        </SideNav>

        <CopyRightFooter text={APP_NAME} className="inside-footer" />
      </div>
    </div>
  );
}
